import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const getApplicationLixiXml = async (
  constructGet: ConstructGet,
  uuid: string,
  definitionName: string,
): Promise<NonPaginatedResponse<any> | undefined> =>
  constructGet(`${APPLICATION_BASE_PATH}/${uuid}/lixi-xml`, {
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
    },
  });
